<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
export default {
  name: 'Result',
  components: {
    VRuntimeTemplate
  },
  props: {
    step: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  async created () {
    if (isEmpty(wepHtmlToString.fifthSubTemplate)) {
      this.getEmptyTemplate('wepResult.html')
    } else {
      this.includeHtml = wepHtmlToString.fifthSubTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.fifthSubTemplate = res
        this.includeHtml = wepHtmlToString.fifthSubTemplate
      })
    },
    fnTab () {
      let obj = {
        stepNum: this.step,
        params: {
        }
      }
      this.$emit('fnTab', obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Result.vue